import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 80%;
  border-radius: 20px;
  border-top-right-radius: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #66666699;
  border: 1px solid #cccccc;
  padding: 9px 19px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

type Props = {
  message: string;
};

export const OriginalText = ({ message }: Props) => {
  return <Wrapper>{message}</Wrapper>;
};
